import { TrackableProperties } from '@lightspeed-payments/payments-portal-sdk';
import { getMerchantDetails } from 'root/apps/tracking/getMerchantDetails';
import { useTracking } from 'root/apps/tracking/TrackingContext';

export const useCapitalTracking = ({ source }: { source: string }) => {
  const { trackEvent } = useTracking();
  const { pli, merchantName } = getMerchantDetails();

  const trackCapitalEvent = (eventName: string, eventProp: TrackableProperties) => {
    try {
      trackEvent(eventName, {
        source,
        ...eventProp,
        merchant_name: merchantName,
        pli,
        product_id: 'r-series',
        surface: 'r-series',
      });
    } catch {
      // We don't want unmounted components throwing errors for tracking
      // The failure under the hood is handled by the payments package
    }
  };

  return {
    trackCapitalEvent,
  };
};
